import style from './styles/FormStep.scss';

/**
 * @property {FormStepConfig} props.step
 * @property {string}         props.activeStep
 * @property {boolean}        props.checked
 */
const FormStep = ({ step, activeStep, hasArrow, checked }) => (
	<div className={'col-4' + (step.name === activeStep ? ` ${style.active}` : '')}>
		<img className={style.icon} src={step.image} />
		{checked === true ? <i className={`fa fa-check ${style.checked}`} /> : null }
		{hasArrow === true ? <i className={style['arrow-right']} /> : null }
		<div className={style.name}>{step.name}</div>
	</div>
);

export default FormStep;


// WEBPACK FOOTER //
// ./components/blocks/raffleForm/FormStep.js